module.exports = __webpack_public_path__ + "img/1-03.c48a95e8.png";